import React from "react";
import ReactMarkdown from 'react-markdown';

export default class MapAreaA extends React.Component{

    state = {
        embedded: this.props.fields.googleMapsEmbeddedCode ? this.props.fields.googleMapsEmbeddedCode : ''
    }

    render(){
        return(
            <div className="row map-area-a">
                <ReactMarkdown skipHtml={false}>
                    {this.state.embedded}
                </ReactMarkdown>
            </div>
        );
    }
}
